<input
  #textInput
  class="input__field"
  aria-invalid="true"
  [name]="name"
  [placeholder]="label"
  [required]="required"
  [readonly]="this.readonly"
  [type]="this.type"
  [disabled]="this.disabled"
  [value]="this.value"
  [autocomplete]="this.autocomplete"
  (input)="onChange(textInput.value)"
  (blur)="onTouched()"
  [ngClass]="{
    input: true,
    disabled: this.disabled,
    invalid: control.status === 'INVALID' && control.touched,
    valid: control.status === 'VALID',
  }"
  (input)="handleValue($event)"
/>

<label class="input__label" [htmlFor]="this.name" [ngClass]="{ disabled: this.disabled }">
  {{ label }}
</label>

@if (icons && !this.readonly) {
  <app-validation-icon
    [status]="control.valid ? 'valid' : control.touched ? 'invalid' : undefined"
  />
}
